import { IConstructionProgressStage } from '../../../../../types/constructionProgress';
import { formatDate } from '../../../../../utils/formatters';
import { ITabProps } from '../../../../Tabs';

export const prepareTabs = (stages: IConstructionProgressStage[]): ITabProps[] => {
  return stages.map((stage, idx) => ({
    title: formatDate(stage.date),
    value: String(idx),
  }));
};
